// Fluids (ENG-14). In M2 water is a STATIC sea fill placed at generation (see
// gen/overworld/surface.ts) — no levels, spread, or sources yet; flowing water/
// lava arrives in M9. This module holds the shared fluid queries.

export type FluidCheck = (x: number, y: number, z: number) => boolean;

/** Is the entity at (x,y,z) submerged? Samples the lower body (feet + 0.5). */
export function isBodyInFluid(isFluid: FluidCheck, x: number, y: number, z: number): boolean {
  return isFluid(Math.floor(x), Math.floor(y + 0.5), Math.floor(z));
}
